import { createStyles, makeStyles } from '@mui/styles'

const useStyles = makeStyles(() =>
  createStyles({
    box: {
      display: 'flex',
      padding: '15px 25px 15px',
      height: '100%',
      width: '100%',
      border: '1px solid #C4C4C440',
      borderRadius: 10,
      background: '#F8F8F8',
    },
    box__inner: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      width: '100%',
      gap: 5,
      position: 'relative',
    },
    title: {
      display: 'grid',
      gridTemplateColumns: '1fr 200px',
      gap: 25,
      width: '100%',

      '& > span': {
        fontSize: 14,
        fontWeight: 700,
        lineHeight: '150%',
        textAlign: 'left',
        margin: 'auto 0',
      },

      '& .MuiInputBase-root': {
        minHeight: '30px !important',
      },

      '& [role="combobox"].MuiSelect-select': {
        marginRight: 35,
        paddingRight: '0 !important',
        textTransform: 'unset',
        minHeight: 'unset !important',
        height: 'unset !important',
        paddingLeft: 10,
        fontSize: 14,
        display: '-webkit-box',
        ' -webkit-line-clamp': 1,
        '-webkit-box-orient': 'vertical',
        overflow: 'hidden',
        whiteSpace: 'normal',
        textOverflow: 'ellipsis',
      },
    },
    chart: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      gap: 15,
      width: '100%',
    },
    compared: {
      fontSize: 15,
      fontWeight: 700,
      lineHeight: '140%',
      color: '#00000099',
      transform: 'translateX(0px)',
      '& span': {
        // color: '#27AE60',
        marginRight: 5,
      },
    },
    low: {
      '& span': {
        color: '#D86565',
      },
    },
    empty: {
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      paddingTop: 20,
    },
    hidden: {
      display: 'none',
      pointerEvents: 'none',
    },
  })
)

export default useStyles
